import { createBrowserRouter } from 'react-router';
import { RootLayout } from 'src/components/layout/root-layout.tsx';
import { CheckPage } from 'src/pages/check-page.tsx';
import { ContextPage } from 'src/pages/context-page.tsx';
import { LandingPage } from 'src/pages/landing-page.tsx';
import { LeadPage } from 'src/pages/lead-page.tsx';
import { NotFound } from 'src/pages/not-found.tsx';
import { ResultRoute } from 'src/pages/result-route.tsx';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: LandingPage },
      { path: 'check', Component: CheckPage },
      { path: 'context', Component: ContextPage },
      { path: 'lead', Component: LeadPage },
      { path: 'result', Component: ResultRoute },
      { path: '*', Component: NotFound }
    ]
  }
]);
